const donationFrequencies = ["Monthly", "Quarterly", "Annually"];

export default donationFrequencies;
